import { MetricsTextInputRowCtrl } from './metrics-text-input-row.controller';

export const MetricsTextInputRowComponent = {
  controller: MetricsTextInputRowCtrl,
  bindings: {
    label: '<',
    metrics: '<',
    buttonState: '<',
  },
  template: require('./metrics-text-input-row.html'),
};
